import React from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";
import { useFormikContext } from "formik";

export default function DeleteQuestionDialog({
    showDialog,
    deleteIndex,
    removeCallback,
    setDeleteArrayState,
    onClose,
    handleClose,
}) {
    const { values } = useFormikContext();

    const onConfirmDelete = () => {
        const question_id = values.questions?.[deleteIndex]?.id;
        if (question_id) {
            setDeleteArrayState((arr) => [...arr, question_id]);
        }
        removeCallback(deleteIndex);
        handleClose();
        onClose();
    };

    const closeOnly = () => {
        handleClose();
        onClose();
    };

    return (
        <Dialog open={showDialog} handler={handleClose} className="dialog">
            <DialogHeader className="dialog__header">
                <p>Delete Question?</p>
            </DialogHeader>
            <DialogBody className="dialog__body">
                {
                    "Are you sure you want to do this? It will permanently remove the selected question from your survey."
                }
            </DialogBody>
            <DialogFooter className="dialog__footer">
                <Button
                    type="button"
                    variant="filled"
                    className="btn btn--secondary"
                    onClick={() => closeOnly()}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    className="btn btn--primary"
                    variant="filled"
                    onClick={() => onConfirmDelete()}
                >
                    Delete
                </Button>
            </DialogFooter>
        </Dialog>
    );
}
